import { Row, Space,Button,Badge, Col } from 'antd';
import {PlusCircleFilled,MinusCircleFilled} from '@ant-design/icons';
import React, {useEffect, useState } from 'react';
import ReactDOM from "react-dom";
import { getLabList, getOnlinePaymentGateway, getSMSrequestBalance } from '../../api/api';
import CustomTable from '../../components/_common/Table';
import { useAppDispatch, useAppSelector } from '../../redux/store/storehooks';
import type { ColumnsType } from 'antd/es/table';
import { UpdateMachineList } from '../../redux/reducers/machinelistSlice';
import { errorNotify, errorNotifyByErrorObject, sucessNotify } from '../../services/toast.notification';
import { ButtonContainer, LabListContainer, SumContainer } from './styles';
import { UpdateSMSPurchaseList } from '../../redux/reducers/smsPurchaseSlice';
import CustomSelect from '../../components/_common/CustomSelect';
import { UpdateLabList } from '../../redux/reducers/lablistSlice';
import { ApplySMSRequestDialog } from './applySMSRequest';
import { BuySMSCreditDialog } from './buySMSCreditDialog';
import CustomSelectAntDesign from '../../components/_common/CustomSelectAntDesign';


const SMSRequest = () => {

  
    const myStore = useAppSelector((state) => state)
    const dispatch = useAppDispatch();
    const [isLoading,setIsLoading] = useState(true);
    const [selectedLab,setSelectedLab] = useState("0");
    const [labList,setLabList] = useState<any[]>([]);
    const [showApplyDialog,setShowApplyDialog] = useState(false);
    const [applyDialogPayload,setApplyDialogPayload] = useState({int_ReminderAmount:0,int_ReminderQuantity:0,labId:0});
    const [showBuySMSDialog,setShowBuySMSDialog] = useState(false);
    const [buySMSDialogPayload,setBuySMSDialogPayload] = useState({onlinePaymentGateway:undefined});

    const [reminderAmount,setReminderAmount] = useState(0);
    const [reminderQuantity,setReminderQuantity] = useState(0);
    const [permission,setPermission] = useState(false);

    const columns: ColumnsType<any> = [
        { title: '-',dataIndex: 'int_Type',key: 'int_Type',render:(_,record) => (
         <Space size="middle">
                {permission && record.int_Type=== 0 ? <PlusCircleFilled disabled={!permission} style={{ color: 'Green',fontSize: '18px' }}/> :permission && <MinusCircleFilled disabled={!permission} style={{ color: 'red',fontSize: '18px' }}/>}
                <label>{permission && record.int_Type === 0 ? 'سفارش' :permission && 'اعمال'}</label>
            </Space>

        )},
        {title: 'آزمایشگاه',dataIndex: 'str_LabPersianName',key: 'str_LabPersianName'},
        {title: 'تاریخ ثبت',dataIndex: 'str_Date',key: 'str_Date'},
        {title: 'تعداد خرید',dataIndex: 'int_Quantity',key: 'int_Quantity',render:(_,record) => (
            <Space size="middle">
                <label>{record.int_Quantity.toLocaleString()}</label>
            </Space>
        )},
        {title: 'مبلغ خرید',dataIndex: 'int_Price',key: 'int_Price',render:(_,record) => (
            <Space size="middle">
                <label>{record.int_Price.toLocaleString()}</label>
            </Space>
        )},
        {title: 'تعداد اعمال شده',dataIndex: 'int_AppliedCount',key: 'int_AppliedCount',render:(_,record) => (
            <Space size="middle">
                <label>{record.int_AppliedCount.toLocaleString()}</label>
            </Space>
        )},
        {title: 'مبلغ اعمال شده',dataIndex: 'int_AppliedPrice',key: 'int_AppliedPrice',render:(_,record) => (
            <Space size="middle">
                <label>{record.int_AppliedPrice.toLocaleString()}</label>
            </Space>
        )},
        {title: 'اعمال کننده',dataIndex: 'str_FullName',key: 'str_FullName'},
        // {title: '',dataIndex: 'Action',key: 'Action',render:(_,record) => (
        //     <Space size="middle">
        //          {(myStore.auth.loginType === 'labuser' && record.int_Type === 1) && (
        //              <Button type="primary" style={{backgroundColor:"blue"}} onClick={()=>downloadReport(record.prk_AutoID)}>دانلود فاکتور</Button>
        //          )}                      
        //     </Space>
        // )}, 
    ];

    useEffect(()=>{


        if (myStore.auth.loginType === 'labuser') {
            LoadSMSRequestBalance(myStore.auth.userId);
           
            setPermission(true);
        }
        else
        {
            if (!myStore.labList.list){
                loadLabs()
            }
            else {
                setLabList(myStore.labList.list);
                LabListInitilization(myStore.labList.list);
                LoadSMSRequestBalance(selectedLab)
            }
            myStore.auth.permission.map((item:any)=>{   
                if(item.pageName == 'SMSRequest')
                    setPermission(item.isDetailAccess);
            });
        }

    },[])

    const loadLabs = () => {

        getLabList()
        .then((result:any) => {
            dispatch(UpdateLabList({labList:result.data.data}))
            setLabList(myStore.labList.list);
            LabListInitilization(myStore.labList.list)
            LoadSMSRequestBalance(0)
            setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          error(error,undefined,5000)
        })

    }

    const LabListInitilization = (labItems:any) => {

        let allLabItem = {prk_AndriodLab_AutoID:0,str_LabPersianName:"همه آزمایشگاه ها"}
        setLabList([allLabItem,...labItems])

    }

    const LoadSMSRequestBalance = (labId:any) => {
        
        setIsLoading(true);

        getSMSrequestBalance(myStore.auth.loginType === 'labuser' ? myStore.auth.userId : labId)
        .then((result:any) => {
            dispatch(UpdateSMSPurchaseList({smsPurchaseList:result.data.data}))
            briefCalculator(result.data.data);
            setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          errorNotifyByErrorObject(error,undefined,5000)
        })

    }

    const briefCalculator = (list:any) => {


        if (list != undefined)
        {

            let Amount:number  =0;
            let Quantity:number  =0;

            setReminderAmount(0);
            setReminderQuantity(0);

            list.forEach((element:any) => {
            
                if (element.int_Type===0) {
                    Quantity += element.int_Quantity;
                    Amount += element.int_Price;
                }
                else {
                    Quantity -= element.int_AppliedCount;
                    Amount -= element.int_AppliedPrice;
                }

            });

            setReminderAmount(Amount);
            setReminderQuantity(Quantity);

        }
        else
        {
            setReminderAmount(0);
            setReminderQuantity(0);
        }

    }

    const downloadReport = (id:number) => {
        console.log("add new click!");
    }

    const applySMSDialog = () => {


        setApplyDialogPayload((values:any) => ({
            ...values,
            int_ReminderAmount: reminderAmount,
            int_ReminderQuantity:reminderQuantity,
            labId:selectedLab
          }));

          setShowApplyDialog(true);

    }

    const buySMSCreditDialog = () => {


        getOnlinePaymentGateway()
        .then((result:any) => {
            
            if (result.data.data.length > 0) {

                setBuySMSDialogPayload((values:any) => ({
                    ...values,
                    onlinePaymentGateway: result.data.data,
                  }));

            }

        })
        .catch((error:any) => {
          console.log(error);
          errorNotify(error.response.data.errorMessage,undefined,5000)
        })

        if(myStore.auth.taxInfo.Bit_IsTax)
            setShowBuySMSDialog(true);
        else
            sucessNotify("لطفا برای کسب اطلاعات بیشتر با خانم موسوی تماس بگیرید.");

    }

    return (
        
        <>

            { isLoading === false && myStore.auth.loginType === 'parsicuser' && (
                <LabListContainer>
                    <Row>

                        {selectedLab !="0" && (
                            <Col lg={6} md={6} sm={6} xs={6}>
                                <ButtonContainer>
                                    <Button type="primary" disabled={!permission} style={{backgroundColor:"Blue"}} onClick={applySMSDialog}>اعمال خرید</Button>
                                </ButtonContainer>
                            </Col>
                        )}

                        
                        <Col lg={selectedLab !="0" ? 18 : 24} md={selectedLab !="0" ? 18 : 24} sm={selectedLab !="0" ? 18 : 24} xs={selectedLab !="0" ? 18 : 24}>
                            {/* <CustomSelect
                                name="lab"
                                placeholder="آزمایشگاه"
                                itemList={labList}
                                value={selectedLab || "0"}
                                onChange={(x:any) => {setSelectedLab(x.target.value);LoadSMSRequestBalance(x.target.value)}}
                                valueObjectField={"prk_AndriodLab_AutoID"}
                                displayObjectField={"str_LabPersianName"}
                            /> */}
                            <CustomSelectAntDesign
                                name="lab"
                                placeholder="آزمایشگاه"
                                itemList={labList}
                                value={(selectedLab=="" || selectedLab=="0") ? "همه آزمایشگاه ها" : selectedLab}
                                onChange={(x: any) => { setSelectedLab(x); LoadSMSRequestBalance(x) }}
                                valueObjectField={"prk_AndriodLab_AutoID"}
                                displayObjectField={"str_LabPersianName"}
                                showSearch={true}
                            />
                        </Col>
                    </Row>
                </LabListContainer>
            )}


            <Row>
                <CustomTable columns={columns} data={myStore.smsPurchaseList.list} isloading={isLoading} onAddClick={myStore.auth.loginType === 'labuser' ? buySMSCreditDialog : undefined} 
                addButtonTitle={myStore.auth.loginType === 'labuser' ? "خرید شارژ پیامک" : ""} permission={permission} />
            </Row>

            { isLoading === false && myStore.smsPurchaseList.list != undefined && (
                <SumContainer>
                    <Row align='middle'>                       
                        <Col>باقیمانده ریالی: {reminderAmount.toLocaleString()} </Col>
                    </Row>
                    <Row align='middle'>                       
                        <Col>باقیمانده عددی: {reminderQuantity.toLocaleString()} </Col>
                    </Row>
                </SumContainer>
            )}


            {showApplyDialog && (
                <ApplySMSRequestDialog
                    visible={showApplyDialog}
                    onSubmit={() => console.log(true)}
                    onCancel={() => {setShowApplyDialog(false);LoadSMSRequestBalance(selectedLab);}}
                    payLoad={applyDialogPayload}
                    setShowDialog= {(value) => setShowApplyDialog(value)}
                /> 
            )}

            {showBuySMSDialog && (
                <BuySMSCreditDialog
                    visible={showBuySMSDialog}
                    onSubmit={() => console.log(true)}
                    onCancel={() => {setShowBuySMSDialog(false);LoadSMSRequestBalance(selectedLab);}}
                    payLoad={buySMSDialogPayload}
                    setShowDialog= {(value) => setShowBuySMSDialog(value)}
                /> 
            )}

        </>
    );
};

export default SMSRequest